import { createQueryKeyStore } from '@lukemorales/query-key-factory';
import { AxiosInstance } from 'axios';

import { API_PREFIX_ADMIN } from '../../../constants.ts';

import { TAdminAuthCheckResponse } from './types.ts';

export class AdminApiAuthService {
    #QUERY_KEYS = createQueryKeyStore({
        auth: {
            check: () => ({
                queryKey: ['auth-check'],
                queryFn: () => this.#authCheck(),
            }),
        },
    });

    constructor(private api: AxiosInstance) {
        this.api = api;
    }

    authCheck() {
        return this.#QUERY_KEYS.auth.check();
    }

    async logout() {
        const { data } = await this.api.get(API_PREFIX_ADMIN + '/logout', {
            headers: {
                'Content-Type': 'application/json',
            },
        });

        return data;
    }

    async #authCheck(): Promise<TAdminAuthCheckResponse> {
        const { data } = await this.api.get<TAdminAuthCheckResponse>(
            API_PREFIX_ADMIN + '/auth-check',
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );

        return data;
    }
}
